import type { DiagnosticResponse, Severity } from '@/types/analytics';

const DOT_COLOR: Record<Severity, string> = {
  red:    'bg-red-500',
  yellow: 'bg-amber-500',
  green:  'bg-green-500',
};

interface DiagnosticSummaryProps {
  data: DiagnosticResponse | undefined;
  isLoading: boolean;
}

export function DiagnosticSummary({ data, isLoading }: DiagnosticSummaryProps) {
  if (isLoading || !data || data.bullets.length === 0) return null;

  const { bullets, overall_health } = data;

  return (
    <div className="rounded-lg bg-slate-50 border border-slate-200 dark:bg-slate-900/50 dark:border-slate-800 p-4 mb-4">
      <div className="flex items-center gap-2 mb-2.5">
        <span className={`h-2 w-2 rounded-full shrink-0 ${DOT_COLOR[overall_health]}`} />
        <span className="text-sm font-medium text-foreground">Pipeline Health</span>
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-1.5">
        {bullets.map((bullet, i) => (
          <div key={i} className="flex items-center gap-1.5 text-xs text-muted-foreground">
            <span className={`h-1.5 w-1.5 rounded-full shrink-0 ${DOT_COLOR[bullet.severity]}`} />
            <span>{bullet.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
